import { defineStore } from 'pinia'
import { envToConfig } from '@/env'
import {
  apiResultTracking,
  initialApiState,
} from '@/legacy/types/api/apiBuilder'
import { Config, ConfigState } from '@/legacy/types/api/config'

const initialState = (): ConfigState => ({
  ...initialApiState(),
  configVals: null,
  rumClient: null,
  logsClient: null,
})

/**
 *
 * @param configVals
 */
function transform(configVals: Config | null): Partial<ConfigState> {
  return { configVals }
}

export const useConfigStore = defineStore('config', {
  state: initialState,
  getters: {
    _isNonProd: (state) =>
      !!state.configVals && state.configVals.env !== 'prod',
    shouldShowEnvironmentBanner(): boolean {
      return this._isNonProd
    },
    shouldAllowApiUrlSwitch: (state) => state.configVals?.env === 'dev',
  },
  actions: {
    ...apiResultTracking<ConfigState, Config>(transform),
    get() {
      this.loading()
      const config = envToConfig()
      this.success(config)
    },

    setApiUrl(apiUrl: string) {
      if (this.configVals) {
        this.success({ ...this.configVals, apiUrl })
        console.debug(`Api URL set to: ${apiUrl}`)
      } else {
        console.error('Cannot set API url without config loaded')
      }
    },
  },
})
